/* Finite, progressive-enhancement motion; never hides purchase controls or content. */
(() => {
  const initialize = () => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const active = new Set();
    const menu = document.querySelector('.nfs-mobile-menu');
    menu?.addEventListener('click', event => { if (event.target.closest('a')) menu.open = false; });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu?.open) { menu.open = false; menu.querySelector('summary')?.focus(); }
    });
    document.addEventListener('click', event => { if (menu?.open && !menu.contains(event.target)) menu.open = false; });
    if (!('IntersectionObserver' in window) || reduced.matches) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const element = entry.target;
        observer.unobserve(element);
        element.dataset.nfsRevealed = 'true';
        if (reduced.matches || !element.animate) return;
        const animation = element.animate(
          [{ opacity: 0.35, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: 480, easing: 'cubic-bezier(.2,.65,.3,1)', iterations: 1 }
        );
        active.add(animation);
        animation.finished.catch(() => {}).finally(() => active.delete(animation));
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.nfs-hero-copy, .nfs-hero-photo, .nfs-section-heading, .nfs-team-card, .nfs-editorial > div, .nfs-process li, .nfs-specs > div, .nfs-faq > div, .nfs-support, .nfs-footer-main > div, .nfs-footer-main > nav').forEach(element => observer.observe(element));
    reduced.addEventListener('change', event => {
      if (event.matches) { observer.disconnect(); active.forEach(animation => animation.cancel()); active.clear(); }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
